
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import StoreOpenScheduleAddEdit from '@/views/DashView/StoreOpenSchedule/StoreOpenScheduleAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class StoreOpenScheduleItem {
  id: string = '';
  outletCode: string = '';
  orderType: string = '';
  status: string = '';
  beginDate: number = 10000101;
  endDate: number = 99991231;
  beginDay: number = 0;
  endDay: number = 0;
  beginHour: number = 0;
  endHour: number = 0;
}

@Component({
  components: {
    editor: StoreOpenScheduleAddEdit
  }
})
export default class StoreOpenScheduleList extends RemoteDataTable<
  StoreOpenScheduleItem
  > {
  public pageTitle: string = 'Outlet Open Schedule List';

  public newButtonText: string = 'New Outlet Open Schedule';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),

    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'orderType', label: 'Order Type' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({ key: 'beginDate', label: 'Begin Date' }),
    new RemoteDataField({ key: 'endDate', label: 'End Date' }),
    new RemoteDataField({ key: 'beginDay', label: 'Begin Day' }),
    new RemoteDataField({ key: 'endDay', label: 'End Day' }),
    new RemoteDataField({ key: 'beginHour', label: 'Begin Hour' }),
    new RemoteDataField({ key: 'endHour', label: 'End Hour' })
  ];

  // to get page data
  get items(): StoreOpenScheduleItem[] {
    return this.$store.getters.GetAllStoreOpenSchedule;
  }

  get paging(): StoreOpenScheduleItem[] {
    return this.$store.getters.PagingStoreOpenSchedule;
  }

  get sorting(): StoreOpenScheduleItem[] {
    return this.$store.getters.SortingStoreOpenSchedule;
  }

  get filtering(): StoreOpenScheduleItem[] {
    return this.$store.getters.FilteringStoreOpenSchedule;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingStoreOpenSchedule', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringStoreOpenSchedule', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.storeOpenSchedule.pagingStoreOpenSchedule.page = 1;
    }
    this.$store.dispatch('GetAllStoreOpenSchedule');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteStoreOpenSchedule', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.storeOpenSchedule.pagingStoreOpenSchedule.size = page;
    this.$store.dispatch('GetAllStoreOpenSchedule');
  }
}
